import { observer } from 'mobx-react-lite'
import { MdInstallMobile } from 'react-icons/md'
import { pwaManager } from '../PwaManager'
import styles from './InstallButton.module.css'

export const InstallButton = observer(() => {
    if (!pwaManager.canInstall) return null

    return (
        <button
            className={styles['button']}
            onClick={() => pwaManager.promptInstall()}
            aria-label="Встановити додаток на пристрій"
        >
            <MdInstallMobile className={styles['icon']} />
            Встановити
        </button>
    )
})

InstallButton.displayName = 'InstallButton'
